/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */

export const createMap = (token: string, centerLat: number, centerLng: number, container: string): mapkit.Map => {
  // Initialiser MapKit JS
  window.mapkit.init({
    authorizationCallback: (done) => {
      done(token);
    },
  });

  // Opret et nyt kort
  const map: mapkit.Map = new window.mapkit.Map(container);

  // Indstil centrum og zoomniveau
  map.center = new window.mapkit.Coordinate(centerLat, centerLng);
  map.cameraDistance = 600;
  map.isZoomEnabled = true;
  map.isScrollEnabled = true;
  map.isRotationEnabled = true;
  return map;
};

export const setOverlay = (mapkitMap: mapkit.Map, location: IMapLocation): void => {
  if (mapkitMap && location) {
    const coordinates = location.coordinates.map((coordinate) => new window.mapkit.Coordinate(coordinate.latitude, coordinate.longitude));
    if (coordinates.length > 1) {
      coordinates.push(coordinates[0]);
    }

    const polygon: mapkit.PolygonOverlay = new window.mapkit.PolygonOverlay(coordinates, {
      style: new window.mapkit.Style({
        strokeColor: '#003d85',
        lineWidth: 2,
        fillColor: '#003d85',
        fillOpacity: 0.5,
      }),
    });

    mapkitMap.overlays.forEach((overlay) => {
      mapkitMap.removeOverlay(overlay);
    });

    mapkitMap.addOverlay(polygon);

    // set center of map to building
    mapkitMap.center = new window.mapkit.Coordinate(location.latitude, location.longitude);
  }
};
